import { Component, OnInit, EventEmitter } from '@angular/core';
import { CreditService } from '../common/credit.service';
import { CardService } from '../common/card.service';
import { CountryService } from '../common/country.service';

import {MdSnackBar} from '@angular/material';

@Component({
  selector: 'app-card-form',
  templateUrl: './card-form.component.html',
  styleUrls: ['./card-form.component.css', '../app.component.css'],
  providers: [ CreditService, CardService,CountryService ]
})
export class CardFormComponent implements OnInit {

  public card: any;
  creditCard:any;
  public onSave = new EventEmitter();
  public spinner: boolean = false;
  billingStates:any;
  countries:any;
  public users: any;

  constructor(private cardService: CardService, private snackBar: MdSnackBar, private creditService: CreditService,private countryService: CountryService) {
      this.card = {
          id:'',
          userId:'',
          name : '',
          number : '',
          expMonth : '',
          expYear : '',
          cvv : '',
          type : 'visa',
          address1:'',
          address2:'',
          city:'',
          stateId:'',
          state:'',
          zip:'',
          countryId:'',
          country:'',
          sameAsUser:false
      };
  }

  ngOnInit() {
      if(this.creditCard!=''){
          this.card = {
              id:this.creditCard.id,
              userId:this.users.eventUser.userId,
              name : this.creditCard.name,
              number : this.creditCard.number,
              expMonth : this.creditCard.expMonth,
              expYear : this.creditCard.expYear,
              cvv : this.creditCard.cvv,
              type : this.creditCard.type,
              address1:this.creditCard.address1,
              address2:this.creditCard.address2,
              city:this.creditCard.city,
              stateId:this.creditCard.stateId,
              state:this.creditCard.stateName,
              zip:this.creditCard.zip,
              countryId:this.creditCard.countryId,
              country:this.creditCard.countryName,
              eventUserId:this.creditCard.eventUserId,
              sameAsUser:false
          };
      }
      this.countryService.getCountries().subscribe(response => {
          this.countries = response;
          if(!this.card.id) {
              for (var i = 0; i < this.countries.length; i++)
                  if (this.countries[i].name == 'USA') {
                      this.card.countryId = this.countries[i].id;
                      this.billingCountryChanged();
                  }
          }else{
              this.billingCountryChanged();
          }
      });
  }

  save(){
   this.spinner = true;
   this.card.type = this.creditService.parseCardType(this.card.number);
   this.card.userId=this.users.eventUser.userId;
   this.card.eventUserId=this.users.eventUser.id;
   this.cardService.saveCard(this.card).subscribe(
    response => {
     this.spinner = false;
     if(response.status)
     {
      this.onSave.emit();
      this.snackBar.open('Card '+(this.card.id?'updated':'created')+' successfully!', '', {duration: 4000});
     }
     else
     this.snackBar.open(response.msg, '', {duration: 4000});
    },
    error => {
     this.spinner = false;
     this.snackBar.open(error,'',{duration:4000});
    }
   );
  }

  cardFormValid(frm){
   var flag = true;
   if(!frm.valid)
   flag = false;
   if(flag && !this.validateDigit(this.card.number,14,19))
   flag = false;
   if(flag && !this.validateDigit(this.card.cvv,3,4))
   flag = false;
      if(flag && !this.card.address1)
          flag = false;
      if(flag && !this.card.city)
          flag = false;
      if(flag && !this.card.stateId)
          flag = false;
      if(flag && !this.validateZip(this.card.zip,this.card.country))
          flag = false;
      if(flag && !this.card.countryId)
          flag = false;
   return flag;
  }

    billingStateChanged(){
        for(var i=0;i<this.billingStates.length;i++)
            if(this.billingStates[i].id==this.card.stateId)
                this.card.state = this.billingStates[i].name;
    }

    billingSameAsUser(){
        this.spinner = true;
        if(this.card.sameAsUser)
        {
            this.card.name = this.users.eventUser.companyName;
            this.card.address1 = this.users.eventUser.addressLine1;
            this.card.address2 = this.users.eventUser.addressLine2;
            this.card.city = this.users.eventUser.city;
            this.card.stateId = this.users.eventUser.stateId;
            this.card.state = this.users.eventUser.stateName;
            this.card.countryId = this.users.eventUser.countryId;
            this.countryService.getStates(this.users.eventUser.countryId).subscribe(
                    response => {
                    this.spinner = false;
                    this.billingStates = response;
                },
                    error => {
                    this.spinner = false;
                }
            );
            this.card.country  = this.users.eventUser.countryName;
            this.card.zip = this.users.eventUser.zipcode;
        }
        else
        {
            this.spinner = false;
            this.card.name = '';
            this.card.address1 = '';
            this.card.address2 = '';
            this.card.city = '';
            this.card.stateId = '';
            this.card.state = '';
            this.card.countryId = '';
            this.card.country = '';
            this.card.zip = '';
        }
    }


    billingCountryChanged(){
        if(this.card.countryId){
        this.spinner = true;
        this.countryService.getStates(this.card.countryId).subscribe(
                response => {
                this.spinner = false;
                this.billingStates = response;
            },
                error => {
                this.spinner = false;
                this.snackBar.open(error,'',{duration:4000});
            }
        );
        for(var i=0;i<this.countries.length;i++)
            if(this.countries[i].id==this.card.countryId)
                this.card.country = this.countries[i].name;
        }
    }


    validateZip(zip,country){
        return true;
        // if(country=='Canada')
        //     var re = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
        // else
        //     var re = /^\d{5}(-\d{4})?$/;
        // return re.test(zip);
    }

  validateDigit(num,min,max){
   return num.match("^[0-9]{"+min+","+max+"}$");
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/card-form/card-form.component.ts